export type SaveCheckInCauseSelection = {
  id?: string;
  causeValue?: string;
  causeTypeId?: string;
  [key: string]: unknown;
};

type SaveCheckInResult = {
  ok: boolean;
  mode?: string;
  entry?: unknown;
};

// The old Firestore-backed checkInService saved a full check-in (mood +
// duration + causes) in one transaction. experience-backend has no check-in
// persistence endpoint yet (features/check-in/hooks/useCheckInSubmission.ts
// already talks to POST /feeling directly for the mood-only part), so this
// is an honest stub for the remaining call site in useCheckInViewHandlers.
const checkInService = async (
  ..._args: unknown[]
): Promise<SaveCheckInResult> => {
  console.warn(
    "checkInService: experience-backend has no check-in persistence endpoint yet."
  );
  return { ok: false };
};

export default checkInService;
